import { useMutation } from '@apollo/client';
import { loader } from 'graphql.macro';
import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../app/hooks';
import { selectRefreshToken } from '../../appSlice';
import { ReactComponent as ConfirmEmailIcon } from '../../assets/icons/confirmEmail.svg';

const registerUserMutation = loader('../SignupPage/registerUser.graphql');

const RESEND_COOLDOWN_SECONDS = 30;

const CreateAccountEmailPage = () => {
    const refreshToken = useAppSelector(selectRefreshToken);
    const navigate = useNavigate();
    const location = useLocation();
    const [cooldownSeconds, setCooldownSeconds] = useState(0);

    const [registerUser] = useMutation(registerUserMutation);

    useEffect(() => {
        if (cooldownSeconds <= 0) return;

        const timeout = window.setTimeout(() => {
            setCooldownSeconds((current) => current - 1);
        }, 1000);

        return () => clearTimeout(timeout);
    }, [cooldownSeconds]);

    const handleResend = useCallback(() => {
        if (cooldownSeconds > 0) return;

        setCooldownSeconds(RESEND_COOLDOWN_SECONDS);
        registerUser({
            variables: { email: location.state?.email },
        });
    }, [cooldownSeconds, location.state?.email, registerUser]);

    if (refreshToken) navigate('/', { replace: true });

    return (
        <div className="page page--light" id="create_account_email">
            <div
                id="create_account_email_back"
                className="page__close page__close--black"
                onClick={() => navigate('/', { replace: true })}
            >
                <p id="create_account_email_back_icon">&times;</p>
            </div>
            <div
                style={{
                    flex: 1,
                    display: 'flex',
                    alignItems: 'end',
                    justifyContent: 'center',
                    paddingBottom: 50,
                }}
            >
                <ConfirmEmailIcon width={80} height={80} />
            </div>
            <h1
                style={{ textAlign: 'center', paddingBottom: 16 }}
                id="create_account_email_title"
            >
                Check Inbox
            </h1>
            <p
                style={{ textAlign: 'center' }}
                id="create_account_email_message"
            >
                Verify email by clicking <strong>Confirm Email</strong> in the
                message sent to {location.state?.email}.
            </p>
            <p
                style={{
                    flex: 1,
                    justifyContent: 'center',
                    display: 'flex',
                    alignItems: 'center',
                }}
                id="create_account_email_text"
            >
                Didn't receive an email?&nbsp;
                {cooldownSeconds > 0 ? (
                    <span id="create_account_email_resend">
                        Resend in {cooldownSeconds}s
                    </span>
                ) : (
                    <span
                        id="create_account_email_resend"
                        className="link link--blue link--initial-size"
                        onClick={handleResend}
                    >
                        Resend
                    </span>
                )}
                .
            </p>
        </div>
    );
};

export default CreateAccountEmailPage;
